
// 默认配置
const defaultConfig = {
  enabled: true,         // 是否启用上报
  platform: 'ARMS',       // 平台
  environment: 'prod',    // 环境
  reporter: null,         // 自定义函数
  globalTags: {}          // 全局附加参数
}

// 合并配置
let config = { ...defaultConfig }

/**
 * 配置错误上报
 * @param {Object} customConfig - 自定义配置
 */
export function configureErrorReporter(customConfig) {
  config = { ...config, ...customConfig }
  // 台特定默认处理逻辑
  if (!config.reporter) {
    switch (config.platform) {
      case 'ARMS':
        config.reporter = armsReporter
        break
      default:
        config.reporter = defaultReporter
    }
  }
}

/**
 * vue文件上报函数
 * @param {String | Required} msg - 必填，错误说明（例如：登录接口错误，某某业务函数错误）
 * @param {Error} error - 错误对象
 * @param {Object} vm - Vue实例
 * @param {Object} context - 上报内容
 */
export function reportErrorFromVue(msg, error, vm, context = {}) {
  reportError(msg, error, {
    filename: vm.$options?.__file,
    ...context
  })
}
/**
 * 上报函数
 * @param {String | Required} msg - 必填，错误说明（例如：登录接口错误，某某业务函数错误）
 * @param {Error} error - 错误对象
 * @param {Object} context - 上报内容
 * @param {String} context.filename - 文件名（vue可以获取）
 * @param {String} context.position - 位置
 * @param {Object} context.other - 其他信息，例如：api相关内容（参数、地址），上下文业务逻辑等
 */
export function reportError(msg, error, context = {}) {
  // 非生产环境打印错误
  if(process.env.NODE_ENV !== 'production') {
    console.log("🚀 ~ reportError ~ error:", error)
  }

  if (!config.enabled) return

  try {
    // 准备上报数据
    const { filename = '', position = '', other = {} } = context
    const errorInfo = {
      error,
      message: msg,
      stack: error?.stack ?? '',
      type: error?.name ?? '',
      filename,
      position,
      other: { ...other },
    }
    // 执行上报
    config.reporter(errorInfo)
  } catch (e) {
    console.error('上传失败:', e)
  }
}

// ------------------ 平台上报函数 ------------------
function armsReporter(errorInfo) {
  if (typeof window !== 'undefined' && window.__bl?.error) {
    const { error, filename, message, position = '', other = {} } = errorInfo
    window.__bl.error(error, {
      filename,
      pos: position,
      c1: message || '',
      c2: JSON.stringify(other),
    })
  }
}

// 默认上报函数
function defaultReporter(errorInfo) {
  console.error('[Error Reporter]', errorInfo)
}


// 默认使用ARMS配置
configureErrorReporter(config)
